import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
// import BaseDatePicker from 'components/BaseDatePicker';
import BaseSelect from 'components/baseSelect' ;
import InputMask from "react-input-mask";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RelativeForm = ({ errors, touched, handleChange, values, element, removeRelativeForm, options, setFieldValue }) => {
    const onRemoveForm = () => removeRelativeForm(element.id);

    return (
        <>
            <Form.Group as={Col} md="3" controlId={"validationNames_" + element.id}>
                <Form.Label>Nombres *</Form.Label>
                <Form.Control
                    type="text"
                    name={`names_${element.id}`}
                    placeholder="Pedro José"
                    value={values[`names_${element.id}`]}
                    onChange={handleChange}
                    isValid={touched[`names_${element.id}`] && !errors[`names_${element.id}`]}
                    isInvalid={!!errors[`names_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`names_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="3" controlId={"validationLastNames_" + element.id}>
                <Form.Label>Apellidos *</Form.Label>
                <Form.Control
                    type="text"
                    name={`lastNames_${element.id}`}
                    placeholder="Romero Fuentes"
                    value={values[`lastNames_${element.id}`]}
                    onChange={handleChange}
                    isValid={touched[`lastNames_${element.id}`] && !errors[`lastNames_${element.id}`]}
                    isInvalid={!!errors[`lastNames_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`lastNames_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            {/* <Form.Group as={Col} md="3" controlId={"validationBirthDate_" + element.id}>
                <Form.Label>Fecha de nacimiento </Form.Label>
                <BaseDatePicker
                    values={values}
                    name={`birthDate_${element.id}`}
                    setFieldValue={setFieldValue} />
            </Form.Group> */}

            <Form.Group as={Col} md="3" controlId={"validationBirthDate_" + element.id}>
                <Form.Label> Fecha de nacimiento *</Form.Label>
                <Form.Control
                    type="text"
                    mask="99/99/9999"
                    placeholder={'dd/mm/yyyy'}
                    as={InputMask}
                    name={`birthDate_${element.id}`}
                    value={values[`birthDate_${element.id}`]}
                    onChange={handleChange}
                    isInvalid={!!errors[`birthDate_${element.id}`]}
                />
            </Form.Group>

            <BaseSelect
                md={3}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Relación'}
                name={`kinship_${element.id}`}
                url={'Parentesco?$filter=Laboral eq 0'}
            />

            
            
            <BaseSelect
                md={3}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Profesion'}
                name={`profession_${element.id}`}
                url={'Profesion'}
            />

            <Form.Group as={Col} md="9" controlId={"validationDirection_" + element.id}>
                <Form.Label>Dirección *</Form.Label>
                <Form.Control
                    type="text"
                    name={`direction_${element.id}`}
                    placeholder="Calle No. 10 Santo Domingo"
                    value={values[`direction_${element.id}`]}
                    onChange={handleChange}
                    isValid={touched[`direction_${element.id}`] && !errors[`direction_${element.id}`]}
                    isInvalid={!!errors[`direction_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`direction_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="12">
                <Button onClick={onRemoveForm} variant="outline-primary"><i className="fas fa-trash-alt"></i></Button>
            </Form.Group>
        </>
    )
}

export default RelativeForm;